/* Native forms remain usable without JS. Dawn's own product-form keeps its own submit handler. */
(() => {
  if (window.ssCartInstalled) return;
  window.ssCartInstalled = true;
  let addQueue = Promise.resolve();

  const errorFor = (form) => {
    let error = form.querySelector('[data-ss-cart-error]');
    if (!error) {
      error = document.createElement('p');
      error.className = 'ss-cart__form-error';
      error.dataset.ssCartError = '';
      error.setAttribute('role', 'alert');
      form.appendChild(error);
    }
    return error;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    const drawer = document.querySelector('cart-drawer');
    if (!(form instanceof HTMLFormElement) || !drawer || form.closest('product-form') || form.hasAttribute('data-ss-cart-native') || event.defaultPrevented) return;
    const action = new URL(form.action, window.location.href);
    const addURL = new URL(routes.cart_add_url, window.location.origin);
    if (action.origin !== window.location.origin || action.pathname.replace(/\.js$/, '') !== addURL.pathname.replace(/\.js$/, '')) return;
    event.preventDefault();
    if (form.dataset.ssCartPending === 'true') return;
    const error = errorFor(form);
    error.textContent = '';
    error.hidden = true;
    const formData = new FormData(form);
    formData.set('sections', drawer.getSectionsToRender().map((section) => section.id).join(','));
    formData.set('sections_url', window.SSWorld?.sectionURL() || window.location.pathname);
    const button = event.submitter || form.querySelector('[type="submit"]');
    const buttonWasDisabled = button?.disabled;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    form.dataset.ssCartPending = 'true';
    form.setAttribute('aria-busy', 'true');
    drawer.setActiveElement(button || form);

    addQueue = addQueue.then(async () => {
      let added = false;
      try {
        const response = await fetch(addURL.pathname.replace(/\.js$/, '') + '.js', {
          method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData
        });
        const result = await response.json();
        if (!response.ok || result.status || result.errors) throw new Error(typeof result.description === 'string' ? result.description : window.cartStrings.error);
        added = true;
        await drawer.renderContents(result);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ss-cart', cartData: result });
      } catch (failure) {
        // Never retry a POST: a failed render must not add the same product twice.
        if (added) { window.location.assign(window.SSWorld?.cartURL() || routes.cart_url); return; }
        error.textContent = failure.message || window.cartStrings.error;
        error.hidden = false;
      } finally {
        delete form.dataset.ssCartPending;
        form.removeAttribute('aria-busy');
        if (button) { button.disabled = buttonWasDisabled; button.removeAttribute('aria-busy'); }
      }
    });
  });

  const install = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.syncState();
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => { drawer.syncState(); });
    document.addEventListener('shopify:section:load', () => drawer.syncState());
    window.addEventListener('pageshow', (event) => { if (event.persisted) drawer.refresh(false).catch(() => {}); });
  };
  customElements.whenDefined('cart-drawer').then(install);
})();
